import dayjs from 'dayjs'
import { ACTIVITY_SOON_THRESHOLD_MS } from '../constants/activitySync'

/**
 * Milliseconds from now until the SOON threshold (startDate - 5 min).
 * Negative if the threshold has already passed.
 * Returns null if startDate is missing.
 */
export const msUntilSoonThreshold = (startDate: string | undefined): number | null => {
  if (!startDate) return null
  const threshold = dayjs(startDate).subtract(ACTIVITY_SOON_THRESHOLD_MS, 'milliseconds')
  return threshold.diff(dayjs())
}

/**
 * Milliseconds from now until the activity goes LIVE (startDate).
 * Negative if already started.
 * Returns null if startDate is missing.
 */
export const msUntilLive = (startDate: string | undefined): number | null => {
  if (!startDate) return null
  return dayjs(startDate).diff(dayjs())
}

/**
 * Milliseconds from now until the activity ends (endDate).
 * Negative if already ended.
 * Returns null if endDate is missing.
 */
export const msUntilEnd = (endDate: string | undefined): number | null => {
  if (!endDate) return null
  return dayjs(endDate).diff(dayjs())
}

/**
 * Returns true if the activity is within the SOON window:
 * now >= (startDate - 5min) AND now < startDate.
 */
export const isSoonWindow = (startDate: string | undefined): boolean => {
  if (!startDate) return false
  const now = dayjs()
  const start = dayjs(startDate)
  return now.isAfter(start.subtract(ACTIVITY_SOON_THRESHOLD_MS, 'milliseconds')) && now.isBefore(start)
}
